import React, { useState } from 'react';
import { useTrusteeContext } from '../../context';
import { cardType, cardTypeName, } from '../../../common/interfaces';
import NameForm from '../../../common/views/nameForm/nameForm';
import { RestoreMissingNullValues } from '../../../common/services/NullValueFieldRestorer';
var getFields = function (fields) { return [
    {
        name: 'title',
        type: 'text',
        label: fields.title.label,
        error: fields.title.error,
        maxLength: fields.title.maxlength,
        inputWidth: 1,
        cfg: { mb: 4 },
    },
    {
        name: 'firstName',
        type: 'text',
        label: fields.firstName.label,
        error: fields.firstName.error,
        maxLength: fields.firstName.maxlength,
        inputWidth: 6,
        cfg: { mb: 4 },
    },
    {
        name: 'lastName',
        type: 'text',
        label: fields.lastName.label,
        error: fields.lastName.error,
        maxLength: fields.lastName.maxlength,
        inputWidth: 6,
    },
]; };
var Name = function () {
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useTrusteeContext(), current = _b.current, send = _b.send, i18n = _b.i18n;
    var fields = getFields(i18n.name.fields);
    var state = current.context.trustee;
    var originalValues = {
        title: state.title,
        firstName: state.firstName,
        lastName: state.lastName,
    };
    var onSubmit = function (values) {
        RestoreMissingNullValues(originalValues, values);
        setLoading(true);
        try {
            send('NEXT', { values: values });
            setLoading(false);
        }
        catch (error) {
            console.log(error);
            setLoading(false);
        }
    };
    return (React.createElement(NameForm, { type: cardType.trustee, typeName: cardTypeName.trustee, title: i18n.name.title, sectionTitle: i18n.name.sectionTitle, onSubmit: onSubmit, fields: fields, initialValues: originalValues, loading: loading, nextStep: true }));
};
export default Name;
//# sourceMappingURL=index.js.map